import React from "react";

function escapeRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

const HighlightText = ({ text, query }) => {
  if (!query || !text) return text || null;
  const escaped = escapeRegex(query.trim());
  if (!escaped) return text;
  const regex = new RegExp(`(${escaped})`, "gi");
  const parts = text.split(regex);
  return parts.map((part, i) =>
    part.toLowerCase() === query.trim().toLowerCase() ? (
      <mark key={i} style={{ background: "#fff59d", padding: 0 }}>
        {part}
      </mark>
    ) : (
      part
    )
  );
};

export default HighlightText;
